import axios from '../../config/Axios/axios-instance';
import { Dispatch } from 'redux';
import {
  createPaymentStart,
  createPaymentSuccess,
  createPaymentFail,
  fetchPaymentListStart,
  fetchPaymentListSuccess,
  fetchPaymentListFail,
} from './actions';
import { IntlShape } from 'react-intl';
import { showToast } from '../../utility/toast/toast';
import { translate } from '../../utility/messageTranslator/translate';
import { PaymentMethod, PaymentStatusTypes } from '../../domain/Payment';
import { ListParams } from '../../hooks/useList/useList';

const API_URL = '/payments';

export type PaymentCreateRequest = {
  packageId: number;
  locationUrl: string;
  paymentMethod: PaymentMethod;
};

export type PaymentListParams = ListParams & { status?: PaymentStatusTypes };

export const fetchPaymentList =
  (params: PaymentListParams, intl: IntlShape) => (dispatch: Dispatch) => {
    dispatch(fetchPaymentListStart());
    return axios
      .get(API_URL, { params })
      .then((response) => {
        dispatch(fetchPaymentListSuccess(response.data));
      })
      .catch((err) => {
        dispatch(fetchPaymentListFail(err?.response?.data?.message));
        showToast(translate(intl, err?.response?.data?.message), 'error');
      });
  };

export const createPayment =
  (inputs: PaymentCreateRequest, intl: IntlShape) => (dispatch: Dispatch) => {
    dispatch(createPaymentStart());
    return axios
      .post(API_URL, { ...inputs })
      .then((response) => {
        dispatch(createPaymentSuccess(response.data));
      })
      .catch((err) => {
        dispatch(createPaymentFail(err?.response?.data?.message));
        showToast(translate(intl, err?.response?.data?.message), 'error');
      });
  };
